import { type CustomCellRendererProps } from 'ag-grid-react'

import { Badge } from '@/components/lemmala-design-system/badge/badge'

/** Renders an ag-grid row-group header as a title plus a child-count badge. */
export const DefaultGroupRowRenderer = <TRow extends Record<string, unknown>>(
  props: CustomCellRendererProps<TRow>,
) => {
  const { node, value } = props
  const valueStr = value as string

  if (!node.group) {
    return null
  }

  return (
    <div className='flex cursor-default items-center gap-1.5 px-4 py-1.5 hover:bg-main-background-muted'>
      <p className='text-main-foreground-primary text-heading-xxsmall'>{valueStr}</p>
      <Badge variant={'neutral'}>{node.allChildrenCount}</Badge>
    </div>
  )
}
